import '@less/registration/registration.less';
import './helpers/global-preferences';
import DemoForm from '@/modules/registration/components/DemoForm.vue';
import PresentationForm from '@/modules/registration/components/PersonalPresentationForm/ModalForm.vue';
import Thanks from '@/modules/registration/components/PresenationThanks.vue';
import { AppHelper } from './helpers/app-helper';

const presentationFormNode = document.querySelector('.js-presentation-form');
if (presentationFormNode) {
  const fields = JSON.parse(presentationFormNode.dataset.fields);
  const errors = JSON.parse(presentationFormNode.dataset.errors);
  const serverErrors = {};
  for (const error in errors) {
    serverErrors[error] = [...errors[error].map((e) => ({ message: e }))];
  }
  AppHelper.createApp(PresentationForm, {
    selector: presentationFormNode,
    props: {
      fields,
      serverErrors
    },
    route: {
      name: 'presentation-form-page'
    }
  });
}

const demoFormNode = document.querySelector('.js-demo-form');
if (demoFormNode) {
  const fields = JSON.parse(demoFormNode.dataset.fields);
  fields.code = demoFormNode.dataset.code;
  const errors = JSON.parse(demoFormNode.dataset.errors);
  const serverErrors = {};
  for (const error in errors) {
    serverErrors[error] = [...errors[error].map((e) => ({ message: e }))];
  }
  AppHelper.createApp(DemoForm, {
    selector: demoFormNode,
    props: {
      fields,
      serverErrors
    },
    route: {
      name: 'demo-form-page'
    }
  });
}

const thanksNode = document.querySelector('.js-demo-request-thanks');
if (thanksNode) {
  AppHelper.createApp(Thanks, {
    route: {
      name: 'demo-request-thanks-page'
    },
    selector: thanksNode
  });
}
